import httpClient from "./httpClient";

const postLogOut = (params) => httpClient.post(`/account/logout/`,params)

export {
    postLogOut,
}
